export const getYears = (startYear: number, reverse: boolean = true) => {
  var currentYear = new Date().getFullYear(), years = [];
  startYear = startYear || 1980;

  while (startYear <= currentYear) {
    years.push(startYear++);
  }
  return reverse ? years.reverse() : years;
}

export const camelToSnake = (s: string) => {
  return s.replace(/[\w]([A-Z])/g, function(m) {
    return m[0] + "_" + m[1];
  }).toLowerCase();
}

export const dcRound = (number: number, currency: boolean = false, override: [boolean, number] = [false, 1], returnString: boolean = false): string | number => {
  //console.log("011524 number",number);
  //console.log("011524 number",number);
  let rounded: number | string;
  if (typeof number === 'number') {
    rounded = number;
  } else {
    rounded = parseFloat(number);
  }
  //console.log("011524 rounded", rounded);
  //console.log("011524 rounded", rounded);
  if (override[0]) {
    rounded = parseFloat(rounded.toFixed(override[1]));
  } else if (currency) {
    if (returnString) {
      rounded = rounded.toFixed(2);
    } else {
      rounded = parseFloat(rounded.toFixed(2));
    }
  } else if (Math.abs(rounded) < 10) {
    rounded = parseFloat(rounded.toFixed(2));
  } else if (Math.abs(rounded) < 100) {
    rounded = parseFloat(rounded.toFixed(1));
  } else {
    if (returnString) {
      rounded = Math.round(rounded).toLocaleString(undefined, { maximumFractionDigits: 0 });
    } else {
      rounded = Math.round(rounded);
    }
  }

  if (returnString) {
    rounded = rounded.toString();
  }

  return rounded;
}

export const queryStringFromObject = (params: Object, initialQuery: string = ''): string => {
  const searchParams = new URLSearchParams(initialQuery);

  for (const [key, value] of Object.entries(params)) {
    if(value) {
      searchParams.append(key, value.toString());
    }
  }

  return searchParams.toString();
}

export const getBearerToken = () => {
  const token = localStorage.getItem('syncarto_jwt');
  return `Bearer ${token}`;
}

export const dev = (arr: number[]) => {
  // Creating the mean with Array.reduce
  let mean = arr.reduce((acc, curr)=>{
    return acc + curr
  }, 0) / arr.length;

  // Assigning (value - mean) ^ 2 to every array item
  arr = arr.map((k)=>{
    return (k - mean) ** 2
  });

  // Calculating the sum of updated array
  let sum = arr.reduce((acc, curr)=> acc + curr, 0);

  // Calculating the variance
  let variance = sum / arr.length;

  // Returning the Standered deviation
  return [mean, Math.sqrt(sum / arr.length)];
}
